{
  "login": "เข้าสู่ระบบ",
  "logout": "ออกจากระบบ",
  "signOut": "ออกจากระบบ",
  "username": "ชื่อผู้ใช้",
  "password": "รหัสผ่าน",
  "forgotPassword": "ลืมรหัสผ่าน?",
  "rememberMe": "จดจำฉัน",
  "loginButton": "เข้าสู่ระบบ",
  "loginError": "ชื่อผู้ใช้หรือรหัสผ่านไม่ถูกต้อง",
  "sessionExpired": "เซสชันของคุณหมดอายุแล้ว กรุณาเข้าสู่ระบบอีกครั้ง",
  "passwordChangedRelogin": "Your password was changed. Please sign in with your new password.",
  "signingIn": "กำลังเข้าสู่ระบบ...",
  "loginSuccess": "เข้าสู่ระบบสำเร็จ",
  "showPassword": "แสดงรหัสผ่าน",
  "hidePassword": "ซ่อนรหัสผ่าน",
  "onboardingPrompt": "สำหรับโรงพยาบาลหรือคลินิก?",
  "onboardingCta": "ขอเริ่มใช้งาน",
  "loginFailed": "เข้าสู่ระบบไม่สำเร็จ",
  "seatCapReached": "ถึงขีดจำกัดผู้ใช้ของใบอนุญาตนี้แล้ว โปรดติดต่อผู้ดูแลระบบ",
  "mfaCodeLabel": "รหัสยืนยัน",
  "mfaCodePrompt": "กรอกรหัส 6 หลักจากแอปตัวรับรองความถูกต้องเพื่อเข้าสู่ระบบให้เสร็จสิ้น",
  "mfaSetupRequired": "องค์กรของคุณกำหนดให้ใช้การยืนยันตัวตนแบบหลายปัจจัย โปรดตั้งค่าแอปยืนยันตัวตนเพื่อดำเนินการต่อ",
  "mfaCodePlaceholder": "รหัส 6 หลัก",
  "mfaInvalidCode": "รหัสยืนยันไม่ถูกต้อง",
  "pages": {
    "userProfile": {
      "title": "โปรไฟล์ของฉัน",
      "loading": "กำลังโหลดโปรไฟล์...",
      "sections": {
        "profilePicture": "รูปโปรไฟล์",
        "personalInformation": "ข้อมูลส่วนตัว",
        "changePassword": "เปลี่ยนรหัสผ่าน",
        "multiFactorAuth": "การยืนยันตัวตนหลายปัจจัย"
      },
      "fields": {
        "fullName": "ชื่อ-นามสกุล",
        "email": "อีเมล",
        "phone": "โทรศัพท์",
        "currentPassword": "รหัสผ่านปัจจุบัน",
        "newPassword": "รหัสผ่านใหม่",
        "confirmPassword": "ยืนยันรหัสผ่านใหม่",
        "required": "*"
      },
      "actions": {
        "saveChanges": "บันทึกการเปลี่ยนแปลง",
        "changePassword": "เปลี่ยนรหัสผ่าน",
        "setUpMfa": "ตั้งค่าการยืนยันตัวตนหลายปัจจัย",
        "uploadAvatar": "อัปโหลด",
        "changeAvatar": "เปลี่ยน",
        "removeAvatar": "นำออก",
        "verify": "ยืนยัน"
      },
      "avatar": {
        "alt": "รูปโปรไฟล์",
        "helperText": "รองรับ PNG, JPEG หรือ WebP ขนาดไม่เกิน 4 MB จะปรับเป็น {{size}}×{{size}} ก่อนอัปโหลด"
      },
      "mfa": {
        "enabledMessage": "บัญชีของคุณเปิดใช้งานการยืนยันตัวตนหลายปัจจัยแล้ว",
        "intro": "เปิดใช้งานการยืนยันตัวตนหลายปัจจัยเพื่อเพิ่มความปลอดภัยให้กับบัญชีของคุณ",
        "scanInstruction": "สแกน URI นี้ด้วยแอปยืนยันตัวตน หรือคัดลอกด้วยตนเอง:",
        "copyUri": "คัดลอก URI",
        "verificationCode": "รหัสยืนยัน",
        "codePlaceholder": "กรอกรหัส 6 หลัก"
      },
      "validation": {
        "fullNameRequired": "กรุณากรอกชื่อ",
        "emailRequired": "กรุณากรอกอีเมลที่ถูกต้อง",
        "currentPasswordRequired": "กรุณากรอกรหัสผ่านปัจจุบัน",
        "newPasswordTooShort": "รหัสผ่านต้องมีอย่างน้อย 8 ตัวอักษร",
        "confirmPasswordRequired": "กรุณายืนยันรหัสผ่าน",
        "passwordsMismatch": "รหัสผ่านไม่ตรงกัน"
      },
      "toasts": {
        "profileUpdated": "อัปเดตโปรไฟล์เรียบร้อยแล้ว",
        "profileUpdateFailed": "อัปเดตโปรไฟล์ไม่สำเร็จ",
        "passwordChanged": "เปลี่ยนรหัสผ่านเรียบร้อยแล้ว",
        "passwordChangeFailed": "เปลี่ยนรหัสผ่านไม่สำเร็จ กรุณาตรวจสอบรหัสผ่านปัจจุบัน",
        "mfaSetupFailed": "ไม่สามารถเริ่มตั้งค่าการยืนยันตัวตนหลายปัจจัย",
        "mfaEnabled": "เปิดใช้งานการยืนยันตัวตนหลายปัจจัยแล้ว",
        "mfaInvalidCode": "รหัสยืนยันไม่ถูกต้อง",
        "avatarUpdated": "อัปเดตรูปโปรไฟล์แล้ว",
        "avatarUpdateFailed": "อัปเดตรูปโปรไฟล์ไม่สำเร็จ",
        "avatarRemoved": "นำรูปโปรไฟล์ออกแล้ว",
        "avatarRemoveFailed": "นำรูปโปรไฟล์ออกไม่สำเร็จ",
        "imageTooLarge": "รูปภาพต้องมีขนาดน้อยกว่า 4 MB",
        "imageTooLargeServer": "รูปภาพใหญ่เกินไป — กรุณาลองไฟล์ที่เล็กกว่านี้",
        "copiedToClipboard": "คัดลอกไปยังคลิปบอร์ดแล้ว"
      }
    }
  },
  "components": {
    "sessionTimeoutWarning": {
      "critical": "เซสชันของคุณจะหมดอายุในไม่ถึง 1 นาที กรุณาบันทึกงานของคุณทันที",
      "expiringSoon_one": "เซสชันของคุณจะหมดอายุในอีก {{count}} นาที",
      "expiringSoon_other": "เซสชันของคุณจะหมดอายุในอีก {{count}} นาที",
      "extendButton": "ต่ออายุเซสชัน"
    }
  },
  "signInMethod": "Sign-in method",
  "signInPassword": "Password",
  "signInDirectory": "Directory",
  "signInSso": "SSO",
  "ldapDirectory": "Directory",
  "ldapLoading": "Loading directories…",
  "ldapEmpty": "No directories configured — contact your administrator.",
  "ssoEmail": "Work email",
  "ssoEmailPlaceholder": "you@hospital.org",
  "ssoContinue": "Continue with SSO",
  "ssoChecking": "Checking…",
  "ssoChoose": "Choose your sign-in provider",
  "ssoContinueWith": "Continue with {{name}}",
  "ssoNoneFound": "No SSO provider for this domain — try password or directory sign-in.",
  "ssoCallbackTitle": "Completing sign-in…",
  "ssoCallbackFailed": "Single sign-on failed",
  "ssoCallbackMissing": "Missing sign-in response — please try again.",
  "ssoBackToLogin": "Back to sign-in",
  "setup": {
    "title": "การตั้งค่าเริ่มต้น",
    "subtitle": "สร้างบัญชีผู้ดูแลระบบบัญชีแรกสำหรับการติดตั้งนี้",
    "username": "ชื่อผู้ใช้",
    "password": "รหัสผ่าน",
    "confirmPassword": "ยืนยันรหัสผ่าน",
    "fullName": "ชื่อเต็ม (ไม่บังคับ)",
    "fullNamePlaceholder": "เช่น สมชาย ใจดี",
    "email": "อีเมล (ไม่บังคับ)",
    "submit": "สร้างบัญชีผู้ดูแลระบบ",
    "submitting": "กำลังสร้างบัญชี…",
    "usernameHint": "3–64 ตัวอักษร: ตัวพิมพ์เล็ก ตัวเลข จุด ขีดล่าง และขีดกลาง",
    "passwordHint": "อย่างน้อย 12 ตัวอักษร มีตัวพิมพ์ใหญ่ ตัวพิมพ์เล็ก ตัวเลข และอักขระพิเศษ",
    "errUsername": "ใช้ 3–64 ตัวอักษร: a–z, 0–9, จุด ขีดล่าง หรือขีดกลาง",
    "errPasswordLength": "รหัสผ่านต้องมีอย่างน้อย 12 ตัวอักษร",
    "errPasswordUpper": "รหัสผ่านต้องมีตัวพิมพ์ใหญ่อย่างน้อยหนึ่งตัว",
    "errPasswordLower": "รหัสผ่านต้องมีตัวพิมพ์เล็กอย่างน้อยหนึ่งตัว",
    "errPasswordDigit": "รหัสผ่านต้องมีตัวเลขอย่างน้อยหนึ่งตัว",
    "errPasswordSpecial": "รหัสผ่านต้องมีอักขระพิเศษอย่างน้อยหนึ่งตัว",
    "errConfirmRequired": "กรุณายืนยันรหัสผ่าน",
    "errConfirmMismatch": "รหัสผ่านไม่ตรงกัน",
    "errFullName": "ชื่อเต็มต้องไม่เกิน 100 ตัวอักษร",
    "errEmail": "กรุณากรอกที่อยู่อีเมลที่ถูกต้อง",
    "successTitle": "สร้างบัญชีผู้ดูแลระบบแล้ว",
    "successBody": "บัญชี “{{username}}” พร้อมใช้งานแล้ว โปรดเข้าสู่ระบบเพื่อดำเนินการต่อ",
    "goToLogin": "ไปหน้าเข้าสู่ระบบ",
    "claimedTitle": "ตั้งค่าเสร็จสมบูรณ์แล้ว",
    "claimedBody": "ระบบนี้มีผู้ดูแลระบบอยู่แล้ว โปรดเข้าสู่ระบบด้วยบัญชีของคุณ",
    "networkError": "ไม่สามารถติดต่อเซิร์ฟเวอร์ได้ โปรดตรวจสอบการเชื่อมต่อแล้วลองอีกครั้ง",
    "retry": "ลองอีกครั้ง",
    "rateLimited": "พยายามหลายครั้งเกินไป โปรดรอหนึ่งนาทีแล้วลองอีกครั้ง",
    "usernameTaken": "ชื่อผู้ใช้นี้ถูกใช้แล้ว",
    "submitFailed": "ไม่สามารถสร้างบัญชีได้ โปรดลองอีกครั้ง"
  }
}
